import type { SchoolResult } from "@/services/schools";
import type {
  OnboardingProgressInput,
  OnboardingSchoolInput,
  PipelineStage,
} from "@/services/pipeline";

/** Map a school search result to the shape the onboarding wizard collects. */
export function toSchoolInput(school: SchoolResult): OnboardingSchoolInput {
  return {
    teamId: school.schoolId,
    schoolName: school.schoolName,
    division: school.division,
    conference: school.conference,
    state: school.state,
    headCoach: school.headCoach,
    headCoachEmail: school.headCoachEmail,
    gender: school.gender,
  };
}

/** Pipeline stages from least to furthest along. */
export const STAGE_ORDER: PipelineStage[] = [
  "researching",
  "reached_out",
  "in_conversation",
  "visited",
  "offered",
];

/**
 * Merge progress entries so each school appears once, keeping the furthest
 * stage (researching < reached_out < in_conversation < visited < offered).
 */
export function mergeProgressEntries(
  entries: OnboardingProgressInput[]
): OnboardingProgressInput[] {
  const byTeam = new Map<string, OnboardingProgressInput>();
  for (const entry of entries) {
    const existing = byTeam.get(entry.teamId);
    if (!existing || STAGE_ORDER.indexOf(entry.stage) > STAGE_ORDER.indexOf(existing.stage)) {
      byTeam.set(entry.teamId, entry);
    }
  }
  return [...byTeam.values()];
}
